import Dictionary from "../../dictionary/dictionary";
import {DictionariesOwnedVehiclesService} from "../../../services/dictionariesOwnedVehiclesService";
import {DictionariesOwnedVehiclesModel} from "../../../models/dictionariesOwnedVehicles";
import {NavLink} from "react-router-dom";
import {routingAddresses} from "../../../../helpers/routing";
import Button from "../../../../common/components/shared/button/button";
import {Api} from "../../../../helpers/api";
import i18n from "../../../../i18n/i18n";
import ReloadButton from "../../../../common/components/shared/reloadButton/reloadButton";
import {SortDirection} from "../../../../common/models/table";

export default class DictionariesOwnedVehiclesList extends Dictionary<DictionariesOwnedVehiclesModel> {
    private sortableElements = ["licencePlate", "name"];

    constructor(props: any) {
        super(props);

        this.canRemove = true;
        this.linkToModify = routingAddresses.dictionaries.ownedVehicles.modify;
    }

    public async componentDidMount() {
        this.getData((await DictionariesOwnedVehiclesService.getAll({
            orderBy: this.state.orderBy,
            sortDirection: this.state.sortDirection
        })));
    }

    public render(): JSX.Element {
        const properties = ["licencePlate", "name"];
        const headers = properties.map(key => i18n.t("dictionaries.ownedVehicles.headers." + key));
        const actions = this.renderActions;
        return (
            <div className="owned-vehicles">
                {this.renderRemovePopup(this.confirmRemove.bind(this))}
                {this.renderWrapperContent(headers, properties,"owned-vehicles", actions, undefined, this.getHeader(), this.sortableElements, this.sortingAction.bind(this))}
            </div>
        );
    }

    private getHeader() {
        return (
            <div className="actions">
                <NavLink to={routingAddresses.dictionaries.ownedVehicles.add} data-testid="add-owned-vehicles">
                    <Button type="primary" text={i18n.t("dictionaries.ownedVehicles.actions.addOwnedVehicle.button")}/>
                </NavLink>
                <ReloadButton
                    reloadFunc={this.reload.bind(this)}
                    testId="dictionaries-owned-vehicle-list-reload-btn"
                />
            </div>
        );
    }

    private async reload() {
        this.reloadList((await DictionariesOwnedVehiclesService.getAll({
            orderBy: this.state.orderBy,
            sortDirection: this.state.sortDirection
        })));
    }

    protected async confirmRemove() {
        this.setState({removeItemResponse: undefined, isWaiting: true});

        const response = await DictionariesOwnedVehiclesService.removeOwnedVehicle(this.state.selectedElement!.id);

        this.setState({removeItemResponse: response});

        if (Api.isSuccess(response)) {
            await this.getData((await DictionariesOwnedVehiclesService.getAll({
                orderBy: this.state.orderBy,
                sortDirection: this.state.sortDirection
            })));
            this.setState({selectedElement: undefined, displayRemovePopup: false});
        } else {
            this.setState({errorMessage: i18n.t("dictionaries.ownedVehicles.errors.removeErrorSuffix")});
        }
        this.setState({isWaiting: false});
    }

    private async sortingAction(orderBy: string, sortDirection: SortDirection) {
        await this.setState({orderBy, sortDirection});
        await this.reload();
    }
}
